import React from 'react';
import BlogPage from '../components/BlogPage';
import postData from '../data/postData';
import '../css/Blog.css'
import '../css/Button.css'
import Autor from '../components/Autor';

function BlogDashboard() {
  return (
    <div className='container-blog'>
      <h1>O que é Dashboard?</h1>
      <Autor />
      <BlogPage posts={postData} />
      <div className='cta-blog'>
        <h3>Quer aprender a criar dashboards de maneira descomplicada? <br /><br /> Clique no botão abaixo e confira! </h3>

        <a href="https://odisseiaonline.com.br/" target='_blank'
          rel='noopener noreferrer'>
          <button className='cta'>APRENDA DASHBOARD</button>
        </a>


      </div>
      <footer>
        <p>Feito com <span style={{ 'color': 'red' }}> &hearts; </span> Odisseia Desenvolvimento Profissional</p>
      </footer>
    </div>
  )
};

export default BlogDashboard;
